import { render, staticRenderFns } from "./CommonRankFollow.vue?vue&type=template&id=05a668fa&scoped=true"
import script from "./CommonRankFollow.vue?vue&type=script&lang=ts"
export * from "./CommonRankFollow.vue?vue&type=script&lang=ts"
import style0 from "./CommonRankFollow.vue?vue&type=style&index=0&id=05a668fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a668fa",
  null
  
)

export default component.exports